import { Component, OnInit } from '@angular/core';
import { OrganizationService } from 'src/app/core-services/organization.service';
import { MaintenanceService } from '../services/maintenance.service';
import { Organization } from 'src/app/client-api.service';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TableButton, TableColumn } from 'src/app/shared/tcc-ui/tables';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss'
  ]
})
export class OrganizationsComponent implements OnInit {
  
  allOrgs: Organization[] | undefined;
  buttons: TableButton<any>[] | undefined;
  columns: TableColumn<Organization>[] | undefined;
  filteredOrgs: Organization[] | undefined;    
  orgs$ = this.organizationService.organizations$;
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  constructor(private maintenanceService: MaintenanceService,
              private organizationService: OrganizationService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.state = 'initializing';  
    this.columns = [
          { title: 'Org Id', name: 'orgId' },
          { title: 'Org Code', name: 'orgCode' },
          { title: 'Name', name: 'name' },
          { title: 'Accounting Method', name: 'accountingMethod' } ,
          { title: 'Meta Json', name: 'meta', contentResolver: (_, row) => this.resolveMeta(row!.meta)! } ,
          { title: 'Lag Month', name: 'lagMonth' },
          { title: 'Property Type Name', name: 'propertyTypeName' },
          { title: 'Entrata Property Id', name: 'entrataPropertyId' }
        ];
    
        this.buttons = [
          {
            data: 'editOrganizationRecord',
            iconClass: 'fas fa-pencil-alt',
            hidden: false,
            buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
            tooltip: 'Edit Organization Record'
          }
        ];
  }

  ngOnInit(): void {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.orgs$.pipe(
      tap((o) => {
        this.allOrgs = o;
        this.filteredOrgs = o;
        this.state = 'ready';
        console.log('OrganizationsComponent Orgs$', o);
      })
    ).subscribe();
  }

  resolveMeta(meta: any) {
    console.log('resolveMetaJson', meta);
    let strigified = JSON.stringify(meta);   
     if(strigified.includes('null')) {
      return null;
     } else {
      return strigified;
     }
  }


  filterOrganizations(event: any) {
    const value = event.target.value;
    this.state = 'loading';
    this.filteredOrgs = this.allOrgs!.filter(a => JSON.stringify(a).toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.state = 'ready';
  }

  openOragnizatinoUpsertPanel(orgId: number) {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');      
    this.router.navigate(['upsert-organization/', orgId], { relativeTo: this.activatedRoute });
  }

  rowClicked(event: any) {    
    if (event.button) {
            if (event.button.data === 'editOrganizationRecord') {
        this.maintenanceService.setMaintenanceComponenetPanelSize('large');
        this.openOragnizatinoUpsertPanel(event.row?.orgId);
      }
    }
  }

  stringify(obj: any) {
    return JSON.stringify(obj);
  }
}
